export class ErrorMesage {
  type: CustomErrorType;
  message: string;

  constructor(type: CustomErrorType, message: string) {
    this.type = type;
    this.message = message;
  }
}

export enum CustomErrorType {
  REQUIRED = 0,
  MAX_LENGTH = 1,
  RANGE = 2,
  COMPARE = 3,
  UNIQUE = 4,
  POSITIVE_NUMBER = 5,
  RANGE_CONTROL = 6,
  EMAIL = 7,
  STRING = 8,
  URL = 9,
  BLANK = 10,
  NOT_EQUAL = 11
}

export interface Operator {
  key: number;
  display: string;
}

export const RangeOperation = {
  GT: {
    key: 0,
    display: 'greater than'
  },
  LT: {
    key: 1,
    display: 'less than'
  },
  EQ: {
    key: 2,
    display: 'equal to'
  },
};
